import { render, staticRenderFns } from "./Pooling.vue?vue&type=template&id=36cec2d1&scoped=true"
import script from "./Pooling.vue?vue&type=script&lang=js"
export * from "./Pooling.vue?vue&type=script&lang=js"
import style0 from "./Pooling.vue?vue&type=style&index=0&id=36cec2d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cec2d1",
  null
  
)

export default component.exports